import React, { useCallback, useEffect, useState } from "react";
import "./header.scss";
import logo from "../../assets/msw-logo.png";
import imgNotAvailable from "../../assets/image-not-available.png";
import { NavLink, useLocation } from "react-router-dom";
import { useSidebarData } from "../../hooks/sidebarData";
import { useQuery } from "@tanstack/react-query";
import axios from "../../api/axios";
import DTRSubNav from "./DTRSubNav";
import SettingsSubNav from "./SettingsSubNav";
import LogsSubNav from "./LogsSubNav";
import LeaveSubNav from "./LeaveSubNav";
import NDOTSubNav from "./NDOTSubNav";
import axiosaim from "../../api/axiosaim";

const Header = () => {
  const location = useLocation();
  const { setSidebarData } = useSidebarData();

  const APPROVER_TIMESHEET_TYPE = 1;
  const APPROVER_ADJUSTMENT_TYPE = 2;

  const accesstoken = sessionStorage.getItem("accesstoken") || "";
  const aimtoken = sessionStorage.getItem("aimtoken") || "";
  const uname = sessionStorage.getItem("uname") || "";
  const img = sessionStorage.getItem("img");
  const name = sessionStorage.getItem("name");
  const department = sessionStorage.getItem("department");
  const outletname = sessionStorage.getItem("outlet_name");
  const userimg = img ?? imgNotAvailable;

  const [currentPage, setCurrentPage] = useState("");

  useEffect(() => {
    const path = location.pathname;
    const page = path.includes("dtr")
      ? "dtr"
      : path.includes("leaves")
      ? "leaves"
      : path.includes("nd-ot")
      ? "ndot"
      : path.includes("reports")
      ? "reports"
      : path.includes("settings")
      ? "settings"
      : path.includes("logs")
      ? "logs"
      : "";
    setCurrentPage(page);
  }, [location.pathname]);

  const handleSettingCurrentPage = useCallback(
    (page) => {
      if (page !== currentPage) {
        setCurrentPage(page);
      }

      // Reset sidebar data
      setSidebarData("state", false);
      setSidebarData("key", "");
      setSidebarData("label", "");
      setSidebarData("data", []);
    },
    [currentPage, setSidebarData]
  );

  const { data: role } = useQuery({
    queryKey: ["userrole"],
    queryFn: async () => {
      const res = await axios.get("access/role", {
        headers: { Authorization: `Bearer ${accesstoken}` },
      });
      return res.data?.role;
    },
    enabled: !!accesstoken,
  });

  const { data: manageddepartmentsAIM } = useQuery({
    queryKey: ["managedAIMDepartments", uname],
    queryFn: async () => {
      const res = await axiosaim.get(`getmanageddepartments`, {
        headers: { "X-Aim-Token": aimtoken },
      });
      return res.data;
    },
    enabled: !!uname && !!aimtoken,
    retry: 1,
  });

  const { data: manageddepartments } = useQuery({
    queryKey: ["managedDepartments", uname],
    queryFn: async () => {
      const res = await axios.get(
        `approvals/departments?type=${APPROVER_TIMESHEET_TYPE}&uname=${uname}`,
        {
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "X-Aim-Token": aimtoken,
          },
        }
      );
      return res.data?.response;
    },
    enabled: !!uname && !!accesstoken && !!aimtoken,
  });

  const { data: managedadjustments } = useQuery({
    queryKey: ["managedAdjustments", uname],
    queryFn: async () => {
      const res = await axios.get(
        `approvals/departments?type=${APPROVER_ADJUSTMENT_TYPE}&uname=${uname}`,
        {
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "X-Aim-Token": aimtoken,
          },
        }
      );
      return res.data?.response;
    },
    enabled: !!uname && !!accesstoken && !!aimtoken,
  });

    
    return (
      <div className='header'>
        <div className='topbar'>
            <div className='left-panel'>
                <div className='logo'>
                    <img src={logo} alt='Logo' />
                </div>
                <div className='title'>
                    <h3>Timekeeping Management System</h3>
                    <ul className='nav'>
                        <li><NavLink to="dashboard" onClick={() => handleSettingCurrentPage('dashboard')}>Dashboard</NavLink></li>
                          {['admin', 'manager', 'supervisor','staff'].includes(role) && (
                        <li>
                            <NavLink to="dtr/my-dtr" className={currentPage === 'dtr' ? 'active' : ''} onClick={() => handleSettingCurrentPage('dtr')}>DTR</NavLink>
                        </li>
                          )}
                          {['admin', 'manager', 'supervisor','staff'].includes(role) && (
                        <li>
                            <NavLink to="leaves/my-leave" className={currentPage === 'leaves' ? 'active' : ''} onClick={() => handleSettingCurrentPage('leaves')}>Leaves</NavLink>
                        </li>
                          )}
                          {['management'].includes(role) && (
                        <li>
                            <NavLink to="leaves/requests" className={currentPage === 'leaves' ? 'active' : ''} onClick={() => handleSettingCurrentPage('leaves')}>Leaves</NavLink>
                        </li>
                          )}
                          {['admin', 'manager', 'supervisor','staff'].includes(role) && (
                        <li>
                            <NavLink to="nd-ot/my-request" className={currentPage === 'ndot' ? 'active' : ''} onClick={() => handleSettingCurrentPage('ndot')}>ND/OT</NavLink>
                        </li>
                          )}
                          {['management'].includes(role) && (
                        <li>
                            <NavLink to="nd-ot/all-requests" className={currentPage === 'ndot' ? 'active' : ''} onClick={() => handleSettingCurrentPage('ndot')}>ND/OT</NavLink>
                        </li>
                          )}
                        {['admin'].includes(role) && (
                            <>
                                <li><NavLink to="reports" className={currentPage === 'reports' ? 'active' : ''} onClick={() => handleSettingCurrentPage('reports')}>Reports</NavLink></li>
                            </>
                        )}
                        {['admin', 'manager', 'supervisor'].includes(role) && (
                            <>
                                <li><NavLink to="settings/devices" className={currentPage === 'settings' ? 'active' : ''} onClick={() => handleSettingCurrentPage('settings')}>Settings</NavLink></li>
                                <li><NavLink to="logs/actions" className={currentPage === 'logs' ? 'active' : ''} onClick={() => handleSettingCurrentPage('logs')}>Logs</NavLink></li>
                            </>
                        )}
                    </ul>
                </div>
            </div>
          <div className="right-panel">
            <div className="details">
              <p>{name}</p>
              <p>{outletname ?? department}</p>
            </div>
            <div
              className="user-img"
              style={{ backgroundImage: `url(${userimg})` }}
            ></div>
          </div>
        </div>

        <div className="subbar">
          <div className="content">
            <div
              className={
                "subnav" +
                ([
                  "dtr",
                  "leaves",
                  "ndot",
                  "reports",
                  "settings",
                  "logs",
                ].includes(currentPage)
                  ? ""
                  : " hide")
              }
            >
              {currentPage === "dtr" && (
                <DTRSubNav
                  role={role}
                  handleSettingCurrentPage={handleSettingCurrentPage}
                  departments={manageddepartments}
                  adjustments={managedadjustments}
                />
              )}
              {currentPage === "leaves" &&
                (role === "admin" ||
                  role === "manager" ||
                  role === "supervisor" ||
                  role === "management") && (
                  <LeaveSubNav
                    role={role}
                    handleSettingCurrentPage={handleSettingCurrentPage}
                    hasManagedDept={manageddepartmentsAIM?.length > 0}
                  />
                )}
              {currentPage === "ndot" &&
              (role === "admin" || manageddepartments?.length > 0 || manageddepartmentsAIM?.length > 0) && (
                <NDOTSubNav
                  role={role}
                  handleSettingCurrentPage={handleSettingCurrentPage}
                  hasManagedDept={manageddepartmentsAIM?.length > 0}
                  hasTMSManagedDept={manageddepartments?.length > 0}
                />
            )}
              {currentPage === "settings" && (
                <SettingsSubNav
                  role={role}
                  handleSettingCurrentPage={handleSettingCurrentPage}
                  manageddepartmentsAIM={manageddepartmentsAIM}
                />
              )}
              {currentPage === "logs" && (
                <LogsSubNav
                  role={role}
                  handleSettingCurrentPage={handleSettingCurrentPage}
                />
              )}
            </div>
          </div>
        </div>
    </div>
  );
};

export default Header;
